// Chave de acesso do CT-e e do MDF-e (0.17.0): os 44 números do código de
// barras do DACTE/DAMDFE (ou do QR code, que traz a chave no endereço).
//   UF (2) · ano e mês (4) · CNPJ de quem emitiu (14) · modelo (2) · série (3)
//   · número (9) · tipo de emissão (1) · código (8) · dígito verificador (1)
// O dígito confere com o módulo 11 (pesos de 2 a 9, da direita para a esquerda).

export const MODELOS = { 55: 'NF-e', 57: 'CT-e', 58: 'MDF-e', 67: 'CT-e OS' };

const UF_DO_CODIGO = {
  11: 'RO', 12: 'AC', 13: 'AM', 14: 'RR', 15: 'PA', 16: 'AP', 17: 'TO', 21: 'MA', 22: 'PI', 23: 'CE', 24: 'RN', 25: 'PB', 26: 'PE',
  27: 'AL', 28: 'SE', 29: 'BA', 31: 'MG', 32: 'ES', 33: 'RJ', 35: 'SP', 41: 'PR', 42: 'SC', 43: 'RS', 50: 'MS', 51: 'MT', 52: 'GO', 53: 'DF',
};

export function digitoDaChave(primeiros43) {
  let soma = 0;
  let peso = 2;
  for (let i = primeiros43.length - 1; i >= 0; i -= 1) {
    soma += Number(primeiros43[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

// A chave dentro de um texto (só os números, ou o endereço do QR code):
// { chave, uf, ano, mes, cnpj, modelo, tipo, serie, numero } ou null.
export function lerChave(texto) {
  const bruto = String(texto ?? '');
  const candidatos = [bruto.replace(/\D/g, ''), ...(bruto.match(/\d{44}/g) ?? [])];
  for (const chave of candidatos) {
    if (chave.length !== 44 || digitoDaChave(chave.slice(0, 43)) !== Number(chave[43])) continue;
    const uf = UF_DO_CODIGO[Number(chave.slice(0, 2))];
    const mes = Number(chave.slice(4, 6));
    const modelo = chave.slice(20, 22);
    if (!uf || mes < 1 || mes > 12 || !MODELOS[modelo]) continue;
    return {
      chave,
      uf,
      ano: 2000 + Number(chave.slice(2, 4)),
      mes,
      cnpj: chave.slice(6, 20),
      modelo,
      tipo: MODELOS[modelo],
      serie: Number(chave.slice(22, 25)),
      numero: String(Number(chave.slice(25, 34))),
    };
  }
  return null;
}

// "CT-e nº 12345, série 1, de 10/2026, emitido pelo CNPJ 12.345.678/0001-90 (SC)"
export function textoDaChave(c, { nomeDoEmitente = null } = {}) {
  const cnpj = c.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  return `${c.tipo} nº ${c.numero}, série ${c.serie}, de ${String(c.mes).padStart(2, '0')}/${c.ano}, `
    + `emitido por ${nomeDoEmitente ?? `CNPJ ${cnpj}`} (${c.uf})`;
}
